import { apiFetch } from './client'
import type { PortfolioSummary } from '../types/portfolio'
import type { PortfolioDeltaMessage } from '../types/delta'

export function fetchPortfolioSummary(
  portfolioId: string,
): Promise<PortfolioSummary> {
  return apiFetch<PortfolioSummary>(
    `/api/portfolio/${encodeURIComponent(portfolioId)}/summary`,
  )
}

export function fetchPortfolioPositions(
  portfolioId: string,
): Promise<PortfolioDeltaMessage> {
  return apiFetch<PortfolioDeltaMessage>(
    `/api/portfolio/${encodeURIComponent(portfolioId)}/positions`,
  )
}

export interface AllocationResponse {
  allocatedSol: string | null
  allocatedUsd: string
  deployedUsd: string
  availableUsd: string
  totalPortfolioUsd: string
  updatedAt: string | null
  warning: string | null
}

export function fetchAllocation(portfolioId: string): Promise<AllocationResponse> {
  return apiFetch<AllocationResponse>(
    `/api/portfolio/${encodeURIComponent(portfolioId)}/allocation`,
  )
}

export function putAllocation(
  portfolioId: string,
  allocatedSol: string | null,
): Promise<AllocationResponse> {
  return apiFetch<AllocationResponse>(
    `/api/portfolio/${encodeURIComponent(portfolioId)}/allocation`,
    {
      method: 'PUT',
      body: JSON.stringify({ allocatedSol }),
    },
  )
}

export type NavPeriod = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR'
export interface NavPoint { ts: number; navUsd: string }

export function fetchNavHistory(
  portfolioId: string,
  period: NavPeriod,
): Promise<NavPoint[]> {
  return apiFetch<NavPoint[]>(
    `/api/portfolio/${encodeURIComponent(portfolioId)}/nav-history?period=${period}`,
  )
}
